<template>
  <div class="warp">
    <img class="top_bg top_bg2" src="@/assets/img/digitalBooks/bg.png" alt="" />
    <div class="layout_con page_w">
      <!-- content -->
      <my-header @num="num"></my-header>
      <!-- 面包屑 -->
      <div class="crumbs_warp">
        <div class="crumbs_box">
          <div class="flex">
            <i class="crumbs_icon">
              <img src="@/assets/img/common/crumbs_icon.png" alt="" />
            </i>
            <div class="crumbs crumbs_black">
              <router-link class="item" to="/">首页 &gt;</router-link>
              <router-link class="item" to="/digitalBooks">资源列表 </router-link>
            </div>
          </div>
        </div>
        <router-link class="back flex" to="/">返回</router-link>
      </div>
      <div class="retrieval_warp">
        <div class="search_box">
          <input
            class="search_keyword"
            type="text"
            placeholder="请输入古籍书名"
            v-model="keyword"
            @keyup.enter="toSearch"
          />
          <el-select v-model="match" placeholder="" style="width: 100px">
            <el-option :key="item.id" :label="item.label" :value="item.value" v-for="item in matchList" />
          </el-select>
          <div class="search_btn flex" @click="toSearch">
            <button>
              <img src="@/assets/img/common/fangdajing.png" alt="" />
            </button>
          </div>
        </div>
        <div class="classify_warp">
          <div class="classify_box">
            <div class="classify_label">朝代：</div>
            <ul class="classify">
              <li class="item" @click="getDynasty(-1, '')" :class="currentDynasty === -1 ? 'active' : ''">全部</li>
              <li
                class="item"
                v-for="(item, index) in dynastyTabs"
                :key="index"
                @click="getDynasty(index, item.value)"
                :class="currentDynasty === index ? 'active' : ''"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div class="classify_box">
            <div class="classify_label">分级：</div>
            <ul class="classify">
              <li class="item" @click="getLevel(-1, '')" :class="currentLevel === -1 ? 'active' : ''">全部</li>

              <li
                class="item"
                v-for="(item, index) in levelTabs"
                :key="index"
                @click="getLevel(index, item.value)"
                :class="currentLevel === index ? 'active' : ''"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div class="classify_box">
            <div class="classify_label">版本：</div>
            <ul class="classify">
              <li class="item" @click="getVersion(-1, '')" :class="currentVersion === -1 ? 'active' : ''">全部</li>
              <li
                class="item"
                v-for="(item, index) in versionsTabs"
                :key="index"
                @click="getVersion(index, item.value)"
                :class="currentVersion === index ? 'active' : ''"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
          <div class="classify_box">
            <div class="classify_label">分期：</div>
            <ul class="classify">
              <li class="item" @click="getAging(-1, '')" :class="currentAging === -1 ? 'active' : ''">全部</li>
              <li
                class="item"
                v-for="(item, index) in agingTabs"
                :key="index"
                @click="getAging(index, item.value)"
                :class="currentAging === index ? 'active' : ''"
              >
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content_box">
        <div class="side_tabs">
          <div class="top_label">
            <img src="@/assets/img/digitalBooks/title.jpg" alt="" />
          </div>
          <el-tree
            :data="sideTree"
            :props="defaultProps"
            @current-change="handCurrentChange"
            node-key="id"
            :expand-on-click-node="true"
          >
          </el-tree>
        </div>
        <div class="main_warp">
          <div class="top_label">
            <div class="top_title">
              {{ sideTreeName ? `古籍列表 -  ${sideTreeName}` : '古籍列表' }}
            </div>
            <div class="change_btns">
              <div :class="switchMode === true ? 'active' : ''" @click="switchMode = true">
                <i>
                  <img src="@/assets/img/digitalBooks/tupian.png" alt="" />
                  <img src="@/assets/img/digitalBooks/tupian_h.png" alt="" />
                </i>
                <span>图片模式</span>
              </div>
              <div :class="switchMode === false ? 'active' : ''" @click="switchMode = false">
                <i>
                  <img src="@/assets/img/digitalBooks/zhaiyao.png" alt="" />
                  <img src="@/assets/img/digitalBooks/zhaiyao_h.png" alt="" />
                </i>
                <span>摘要模式</span>
              </div>
            </div>
          </div>
          <div v-if="bookList.length > 0">
            <div class="main" v-loading="loading">
              <transition
                name="animate__animated animate__bounce"
                enter-active-class="animate__fadeIn"
                leave-active-class="animate__fadeOut"
                mode="out-in"
              >
                <div class="empty_con" v-if="switchMode" :key="1">
                  <ul class="picture_list">
                    <li v-for="(item, index) in bookList" :key="index" :title="item.name">
                      <router-link class="item" :to="`/digitalBooks/bookDetails/${item.id}`">
                        <div class="item_bg_box flex">
                          <div class="item_bg">
                            <div class="item_img_box">
                              <img class="item_img" :src="encodeURI(item.image)" alt="" />
                            </div>
                          </div>
                        </div>
                        <div class="item_info flex">
                          <p>《{{ item.name }}》</p>
                          <p>[ {{ item.dynasty }} ] {{ item.author }}</p>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
                <div class="empty_con" v-else :key="2">
                  <ul class="book_list">
                    <li class="item" v-for="(item, index) in bookList" :key="index">
                      <div class="item_img_box">
                        <img class="item_img" :src="encodeURI(item.image)" alt="" />
                      </div>
                      <div class="item_info">
                        <div class="item_title">《{{ item.name }}》</div>
                        <p>
                          <span>著作朝代：</span>
                          <span>{{ item.dynasty }}</span>
                        </p>
                        <p>
                          <span>著者：</span>
                          <span>{{ item.author }}</span>
                        </p>
                        <p>
                          <span>版本著明：</span>
                          <span>{{ item.editionDes }}</span>
                        </p>

                        <router-link class="to_details flex" :to="`digitalBooks/bookDetails/${item.id}`"
                          >查看详情</router-link
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </transition>
            </div>
          </div>
          <div v-else class="no_data">
            <img src="@/assets/img/common/no_data.svg" alt="" />
            <p>此项目暂无分类数据</p>
          </div>
          <!-- 分页 -->
          <div class="fy">
            <el-pagination
              background
              :hide-on-single-page="true"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
            <div class="num">古籍： 共{{ species1 }}种 共{{ volume1 }}册 共{{ page1 }}页</div>
          </div>
        </div>
      </div>
      <!-- content end -->
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import myHeader from '@/components/myHeader/index'
import myFooter from '@/components/myFooter/index'
import { getBookList } from '@/api/index.js'
export default {
  metaInfo: {
    title: '宝鸡市扶风县图书馆-古籍文献资源库-资源列表'
  },
  components: {
    myHeader,
    myFooter
  },
  data() {
    return {
      species1: 1,
      volume1: 1,
      page1: 1,
      num: 2,
      keyword: '',
      switchMode: true, //显示模式切换
      sideTreeName: '',
      loading: false,
      currentDynasty: -1, //当前选中的 朝代 下标
      currentLevel: -1, //当前选中的 分级 下标
      currentVersion: -1, //当前选中的 版本 下标
      currentAging: -1, //当前选中的 分期 下标
      dynastyId: '', //当前选中的 朝代 值
      levelId: '', //当前选中的 分级 值
      versionId: '', //当前选中的 版本 值
      agingId: '', //当前选中的 分期 值
      pageSize: 12, //每页显示条目个数
      total: 100, //总页数
      currentPage: 1, //分页当前页数
      sideTree: [],
      sideTreeID: '', //左侧树级 id
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      bookList: [],
      dynastyTabs: [], //朝代
      levelTabs: [], //分级
      versionsTabs: [], //版本
      agingTabs: [], //分期
      matchList: [
        { id: '1', label: '模糊', value: 'like' },
        { id: '2', label: '精准', value: 'eq' }
      ],
      match: 'like'
    }
  },
  mounted() {
    this.fromSearch()
    this.getTopTabs()
    this.getBuildTree()
  },
  methods: {
    // 参数配置
    parameters() {
      let queryParams = {
        page: this.currentPage - 1, //分页从0开始需要-1
        size: this.pageSize,
        name: this.keyword,
        years: this.dynastyId,
        loss: this.levelId,
        edition: this.versionId,
        ancestors: this.sideTreeID,
        period: this.agingId,
        match: this.match
      }
      return queryParams
    },
    // 传递过来参数的搜索
    fromSearch() {
      this.keyword = this.$route.query.keyword
      this.match = this.$route.query.match ? this.$route.query.match : 'like'
      let queryParams = this.parameters()
      this.getBookData(queryParams)
    },
    // 当前页面搜索
    // 当前页面搜索
    toSearch() {
      this.currentPage = 1
      let queryParams = this.parameters()
      this.getBookData(queryParams)
      // 改变路由参数
      this.$router.push({ query: { keyword: this.keyword, match: this.match } })
    },
    //请求列表数据
    async getBookData(data) {
      this.loading = true
      let res = await getBookList({
        ...data
      })
      this.loading = false
      this.total = res.totalElements
      this.bookList = res.content
      console.log(res, 111111)
      this.species1 = res.species
      this.volume1 = res.volume
      this.page1 = res.page
    },
    // 根据 朝代 关键字筛选
    getDynasty(i, value) {
      this.currentDynasty = i
      this.dynastyId = value
      // 重置分页为第一页
      this.currentPage = 1
      let queryParams = this.parameters()
      this.getBookData(queryParams)
    },
    // 根据 分级 关键字筛选
    getLevel(i, value) {
      this.currentLevel = i
      this.levelId = value
      // 重置分页为第一页
      this.currentPage = 1
      let queryParams = this.parameters()
      this.getBookData(queryParams)
    },
    // 根据 版本 关键字筛选
    getVersion(i, value) {
      this.currentVersion = i
      this.versionId = value
      // 重置分页为第一页
      this.currentPage = 1
      let queryParams = this.parameters()
      this.getBookData(queryParams)
    },
    // 根据 分期 关键字筛选
    getAging(i, value) {
      this.currentAging = i
      this.agingId = value
      // 重置分页为第一页
      this.currentPage = 1
      let queryParams = this.parameters()
      this.getBookData(queryParams)
    },

    // 根据 左侧栏目树 关键字筛选
    handCurrentChange(data) {
      this.sideTreeID = data.id
      this.sideTreeName = data.name
      let queryParams = this.parameters()
      this.getBookData(queryParams)
    },
    // 根据 左侧栏目树 关键字筛选
    // handCurrentChange(data) {
    //   this.sideTreeID = data.id
    //   this.sideTreeName = data.name
    //   let queryParams = this.parameters()
    //   this.getBookData(queryParams)
    // },
    // 加载顶部Tabs数据
    async getTopTabs() {
      const dynastyTabs = await this.$http('/api/home/navigation/singleNav?dictName=demo_years&size=100')

      const levelTabs = await this.$http('/api/home/navigation/singleNav?dictName=demo_level')
      const versionsTabs = await this.$http('/api/home/navigation/singleNav?dictName=demo_edition')
      const agingTabs = await this.$http('/api/home/navigation/singleNav?dictName=period')
      this.dynastyTabs = dynastyTabs.content
      this.levelTabs = levelTabs.content
      this.versionsTabs = versionsTabs.content
      this.agingTabs = agingTabs.content
    },
    // 请求左侧tree结构数据
    async getBuildTree() {
      let res = await this.$http.get('/api/home/navigation/buildTree')
      this.sideTree = res.content
    },
    // 分页请求
    async handleCurrentChange(val) {
      this.currentPage = val
      let queryParams = this.parameters()
      this.getBookData(queryParams)
    }
  }
}
</script>

<style lang="less" scoped>
.retrieval_warp {
  width: 100%;
  height: 400px;
  background: url('../../assets/img/digitalBooks/retrieval_bg.png') no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;
  .search_box {
    width: 78%;
    height: 46px;
    display: flex;
    border-radius: 4px;
    overflow: hidden;
    margin: 0 auto;
    margin-top: 50px;
    .search_keyword {
      flex: 1;
      border: 0;
      background: #fff;
      padding: 0 10px;
      color: #9a856d;
      &::-webkit-input-placeholder {
        color: #9a856d;
        font-size: 14px;
        letter-spacing: 2px;
      }
    }
    .search_btn {
      width: 90px;
      background: @theme;
      cursor: pointer;
      button {
        border: 0;
        background: transparent;
        cursor: pointer;
      }
    }
  }
  .classify_warp {
    width: 80%;
    margin: 0 auto;
    margin-top: 50px;
    .classify_label {
      font-size: 14px;
      color: #666;
      margin-right: 10px;
      flex-shrink: 0;
      margin-top: 5px;
    }
    .classify_box {
      display: flex;
      margin-bottom: 15px;
      position: relative;
    }
    .classify {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      overflow: hidden;
      transition: all 0.4s ease;
      li {
        font-size: 14px;
        color: #333;
        padding: 5px 18px;
        cursor: pointer;
        margin-bottom: 10px;
      }
      .active {
        background: @theme;
        border-radius: 12px;
        color: #fff;
      }
    }
  }
}
.content_box {
  display: flex;
  margin-top: 50px;
  .side_tabs {
    width: 260px;
    margin-right: 30px;
  }
  .main_warp {
    flex: 1;
    .empty_con {
      animation-duration: 0.4s;
    }
    .top_label {
      height: 40px;
      padding: 0 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f1ece6;
      box-shadow: 0 1px 6px rgb(0 0 0 / 20%);
      margin-bottom: 30px;
    }
    .change_btns {
      display: flex;
      align-items: center;
      div {
        display: flex;
        align-items: center;
        margin-right: 20px;
        cursor: pointer;
        font-size: 14px;
        i {
          margin-right: 4px;
          img {
            &:nth-child(2) {
              display: none;
            }
          }
        }
      }
      .active {
        color: #a61b29;
        i {
          img {
            &:nth-child(1) {
              display: none;
            }
            &:nth-child(2) {
              display: block;
            }
          }
        }
      }
    }
    // 图片模式
    .picture_list {
      display: flex;
      flex-wrap: wrap;
      li {
        width: 25%;
        // margin-right: 30px;
        margin-bottom: 30px;
        display: flex;
        justify-content: center;
        &:hover {
          .item_img_box {
            transform: rotateY(20deg);
          }
          .item_img {
            transform: rotateY(20deg);
          }
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
      }
      .item {
        display: block;
        .item_bg_box {
          width: 160px;
          height: 230px;
          background: url('../../assets/img/index/book_bg.jpg') no-repeat center;
        }
        .item_bg {
          width: 160px;
          height: 230px;
          background-color: #656566;
          border-radius: 5px;
        }
        .item_img_box {
          width: 100%;
          height: 100%;
          transition: all 0.6s;
          background-color: #fff;
          transform-origin: 100% 0;
          .item_img {
            width: 100%;
            height: 100%;
            transform-origin: 100% 0;
            transition: all 0.6s;
            border-radius: 5px;
          }
        }
      }
      .item_info {
        width: 160px;
        margin-top: 10px;
        flex-direction: column;
        p {
          width: 100%;
          margin: 6px 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: center;
          &:nth-child(1) {
            color: #4e2f0d;
            font-size: 16px;
          }
          &:nth-child(2) {
            color: #9a856d;
            font-size: 14px;
          }
        }
      }
    }
    // 摘要模式
    .book_list {
      .item {
        display: flex;
        padding: 30px;
        transition: all 0.2s ease-out;
        &:hover {
          background: #efe9e1;
        }
      }
      .item_img_box {
        width: 160px;
        height: 230px;
        margin-right: 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .item_info {
        flex: 1;
        position: relative;
        .item_title {
          font-size: 24px;
          color: #4e2f0d;
          margin-bottom: 8px;
          line-height: 1.5;
        }
        p {
          font-size: 14px;
          line-height: 32px;
          span {
            &:nth-child(1) {
              color: #807568;
              float: left;
            }
            &:nth-child(2) {
              color: #544a40;
            }
          }
        }
        .jianjie {
          span {
            &:nth-child(1) {
              float: left;
            }
            &:nth-child(2) {
              height: 64px;
              overflow: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
          }
        }
        .to_details {
          width: 100px;
          height: 34px;
          border: 1px solid #999999;
          border-radius: 4px;
          font-size: 14px;
          color: #333;
          // position: absolute;
          // bottom: 0;
          transition: all 0.2s ease-out;
          margin-top: 20px;
          &:hover {
            background: #c96b06;
            color: #fff;
            border-color: #c96b06;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .picture_list {
    li {
      width: 33% !important;
    }
  }
}
/deep/.el-tree-node__expand-icon.is-leaf {
  color: transparent;
}
/deep/.el-tree-node__content {
  width: 260px;
  height: 40px;
  display: flex;
  align-items: center;
  background: #f6ede2;
  cursor: pointer;
  color: #000;
}
/deep/.el-tree-node__content:hover {
  background-color: #f0e1d1;
}
/deep/.el-tree-node:focus > .el-tree-node__content {
  background: #e2d0bc;
  color: #000;
}
/deep/.el-tree-node__label {
  font-size: 16px;
}
/deep/.el-tree-node__expand-icon {
  color: #000;
  margin-left: 20px;
}
.fy {
  display: flex;
  align-items: center;
  justify-content: center;
  .num {
    margin-left: 25px;
    font-size: 14px;
    font-weight: 400;
    color: #888;
    letter-spacing: 2.8px;
  }
}
div/deep/.el-input__inner {
  -webkit-appearance: none;
  background-image: none;
  /* border-radius: 4px; */
  /* border: 1px solid #DCDFE6; */
  box-sizing: border-box;
  color: #9a856d;
  display: inline-block;
  font-size: inherit;
  height: 48px;
  line-height: 48px;
  outline: 0;
  padding: 0 15px;
  /* transition: border-color .2s cubic-bezier(.645,.045,.355,1); */
  width: 100%;
}
div/deep/.el-input__inner {
  border-radius: 0px;
  border: 0px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
}
</style>
